import { n as i } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
const l = {
  name: "ArrowLeftIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var n = function() {
  var t = this, e = t._self._c;
  return e("span", t._b({ staticClass: "material-design-icon arrow-left-icon", attrs: { "aria-hidden": t.title ? null : !0, "aria-label": t.title, role: "img" }, on: { click: function(r) {
    return t.$emit("click", r);
  } } }, "span", t.$attrs, !1), [e("svg", { staticClass: "material-design-icon__svg", attrs: { fill: t.fillColor, width: t.size, height: t.size, viewBox: "0 0 24 24" } }, [e("path", { attrs: { d: "M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z" } }, [t.title ? e("title", [t._v(t._s(t.title))]) : t._e()])])]);
}, s = [], a = /* @__PURE__ */ i(
  l,
  n,
  s,
  !1,
  null,
  null,
  null,
  null
);
const _ = a.exports;
export {
  _ as A
};
